import store from '../store'
import router from '../router'
import axios from 'axios'

let apiUrl = process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'https://rp-api.karahan.io/api'
// let apiUrl = 'http://127.0.0.1:8000/api'
export default {
  install: (Vue, options) => {
    Vue.prototype.$auth = {
      login: async (email, password) => {
        let user = {}
        // todo remove get variables
        await axios.post(`${apiUrl}/auth/login?email=${email}&password=${password}`).then(async response => {
          user.token = response.data.access_token

          await axios.post(`${apiUrl}/auth/super`, {}, { headers: { 'Authorization': `Bearer ${response.data.access_token}` } }).then(meResponse => {
            // User is super user

            user.me = meResponse.data
            store.commit('UPDATE_USER', { user })
            return user
          }).catch(error => {
            // User is user but not superuser
            console.log(error)
            return { error: 'Unauthorized' }
          })
        })
      },
      me: (() => {
        if (store.getters.user !== null) {
          return store.getters.user.me
        }
      })(),
      apiurl: (() => {
        return apiUrl
      })(),
      token: (() => {
        console.log(store.getters.user)
        if (store.getters.user !== null) {
          console.log(store.getters.user)
          return store.getters.user.token
        }
      })(),
      check: (userType) => {
        if (userType) {
          if (store.getters.user.me.superuser) {
            return true
          }
          if (userType === 'driver' && store.getters.user.me.driver) {
            return true
          }
        } else {
          return false
        }
      },
      logout: async () => {
        store.commit('UPDATE_USER', { user: null })
        router.push('/system/login')
      },
    }
  },
}
/*

    auth.onAuthStateChanged(user => {
      store.commit('UPDATE_USER', { user })
    })
* */
